<div class="coverage-page">
    <div class="container d-flex justify-content-between h-100">
        <div class="info-content">
            <div class="info">
                <div class="portalLogo"></div>
            </div>
            <self-ins-policies-and-request-page></self-ins-policies-and-request-page>
            <div class="footer">
                <a
                    href="https://www.marshmma.com/us/privacy-notice.html"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Privacy Notice
                </a>
            </div>
        </div>
        <div class="main-content flex-row justify-content-between flex-wrap align-items-center">
            <div class="box" (click)="gotoPage('verification-tractors')">
                <img src="../../../assets/car-icon.svg" alt="car-icon">
                <p>Unit ID Cards</p>
            </div>
            <div class="box" (click)="gotoPage('verification-drivers')">
                <img src="../../../assets/driver-icon.svg" alt="driver-icon">
                <p>Driver Information</p>
            </div>
            <div class="box" (click)="gotoPage('coverage-proposal')">
                <img src="../../../assets/policy-icon.svg" alt="policy-icon">
                Insurance Summary
            </div>
            <div class="box" [routerLink]="['/verification']">
                <img src="../../../assets/account-icon.svg" alt="account-icon">
                AFP Account Information
            </div>
            <div class="box" (click)="gotoPage('documents')">
                <img src="../../../assets/document-icon.svg" alt="document-icon">
                Misc Documents
            </div>
            <div class="box" (click)="gotoPage('analytics')">
                <img src="../../../assets/chart-mixed-icon.svg" alt="document-icon">
                Incidents Reported
            </div>
        </div>
    </div>
</div>
